import { Group, Stack, Text } from "@mantine/core";

const TravellerDrawerSection = ({ icon: Icon, label, children }) => (
  <Stack gap={4}>
    <Group gap={8} mb={4}>
      <Icon size={16} color="#6C94B4" />
      <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
        {label}
      </Text>
    </Group>
    {children}
  </Stack>
);

export default TravellerDrawerSection;
